/**
 * API component for filtering entries.
 * @param {string} contentType - The content type to filter.
 * @param {object} imageSizes - The image sizes to use.
 * @param {string} siteHandle - The Craft site handle to scope results.
 * @returns {object} The API component.
 */
export default function api(contentType, imageSizes, siteHandle) {
	return {
		isLoading: false,
		errorMessage: null,

		async fetchEntries(params) {
			this.isLoading = true;
			this.errorMessage = null;

			try {
				const requestBody = {
					section: contentType,
					siteHandle: siteHandle,
					categoryIds: params.selectedCategories,
					topicIds: params.selectedTopics,
					industryIds: params.selectedIndustries,
					search: params.searchTerm,
					limit: params.perPage,
					offset: params.offset,
				};

				if (imageSizes) {
					requestBody.imageSizes = imageSizes;
				}

				const response = await fetch(
					"/actions/filter-module/api/entries",
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"X-Requested-With": "XMLHttpRequest",
						},
						body: JSON.stringify(requestBody),
					},
				);

				const data = await response.json();

				if (!response.ok) {
					throw new Error(
						data.error || `HTTP error! status: ${response.status}`,
					);
				}

				if (data.error) {
					throw new Error(data.error);
				}

				return data;
			} catch (error) {
				console.error("Filter error:", error);
				this.errorMessage =
					error.message ||
					"Failed to load entries. Please try again.";
				return null;
			} finally {
				this.isLoading = false;
			}
		},
	};
}
